@if (!failedResponse) {
  @if (
    accountDetails && !isLoading && !showPendingStatus && !showTimeoutMessage
  ) {
    <!-- ORIGINAL BANK TRANSFER DETAILS SCREEN -->
    @if (show) {
      <div
        id="snackbar"
        style="background-color: #a59800; z-index: 100000; position: absolute"
        class="show"
      >
        Transaction Pending
      </div>
    }
    <div>
      @if (accountDetails) {
        <ng-container>
          <div class="details_info">
            <p style="margin-bottom: 0; margin-top: -1rem; font-size: 10px">
              Kindly proceed to your banking app mobile/internet to complete
              your bank transfer
            </p>
            <p style="margin-bottom: 0; margin-top: -1rem; font-size: 10px">
              <b> Please note the account number expires in 30 minutes</b>
            </p>
          </div>
          <div class="bank-details">
            <p class="no-margin-b">Bank:</p>
            <h5 class="heading__5">{{ accountDetails?.bankName }}</h5>
            <p class="mt-1 no-margin-b">Account Name:</p>
            <h5 class="heading__5">{{ accountDetails?.accountName }}</h5>
            <p class="mt-1 no-margin-b">Account Number:</p>
            <h5 class="heading__5">{{ accountDetails?.accountNumber }}</h5>
          </div>
        </ng-container>
        <div class="form_button">
          <button
            (click)="confirmTransfer()"
            type="submit"
            [disabled]="btnDisabled"
            class="btn w-100 form-btn text-white no-margin-l no-margin-r mt-4"
            [style.background-color]="
              whiteLabelInfo?.brandColor
                ? whiteLabelInfo?.brandColor
                : '#ed1c25'
            "
          >
            <span>I have completed the transfer</span>
          </button>
        </div>
      }
      <div
        class="footer"
        style="margin-top: 10px; text-align: center; font-size: 8px"
      >
        <app-footer [whiteLabelInfo]="whiteLabelInfo" />
      </div>
    </div>
  }

  <!-- PENDING STATE SCREEN - Shows while polling -->
  @if (showPendingStatus) {
    <div class="pending-state-screen">
      <div
        class="pending-content"
        style="text-align: center; padding: 40px 20px"
      >
        <!-- Animated Loader -->
        <div class="animated-loader" style="margin-bottom: 30px">
          <div
            class="spinner-border"
            style="width: 6rem; height: 6rem; color: #ed1c25"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </div>

        <!-- Dynamic Title and Message -->
        <h2
          style="
            color: #333;
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 15px;
          "
        >
          {{ pendingStatusTitle }}
        </h2>

        <p
          style="
            color: #666;
            font-size: 14px;
            line-height: 1.6;
            margin-bottom: 30px;
            max-width: 400px;
            margin-left: auto;
            margin-right: auto;
          "
        >
          {{ pendingStatusMessage }}
        </p>

        <!-- Status Text -->
        <p style="color: #999; font-size: 12px">
          Do not close or refresh this page
        </p>
      </div>

      <!-- Footer -->
      <div
        class="footer"
        style="margin-top: 20px; text-align: center; font-size: 8px"
      >
        <app-footer [whiteLabelInfo]="whiteLabelInfo" />
      </div>
    </div>
  }

  <!-- TIMEOUT MESSAGE SCREEN - Shows after 120 seconds with no response -->
  @if (showTimeoutMessage && !showPendingStatus) {
    <div class="timeout-message-screen">
      <div
        class="timeout-content"
        style="text-align: center; padding: 40px 20px"
      >
        <div style="margin-bottom: 30px">
          <img
            src="../../../assets/rexpay/error.png"
            style="width: 80px; height: 80px"
          />
        </div>

        <h2
          style="
            color: #333;
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 15px;
          "
        >
          Verification Timeout
        </h2>

        <p
          style="
            color: #666;
            font-size: 14px;
            line-height: 1.6;
            margin-bottom: 30px;
            max-width: 400px;
            margin-left: auto;
            margin-right: auto;
          "
        >
          {{ timeoutMessage }}
        </p>

        <!-- Action Buttons -->
        <div
          style="
            display: flex;
            gap: 10px;
            justify-content: center;
            flex-wrap: wrap;
          "
        >
          <button
            type="button"
            class="btn form-btn text-white"
            [style.background-color]="
              whiteLabelInfo?.brandColor
                ? whiteLabelInfo?.brandColor
                : '#ed1c25'
            "
            (click)="startApiCalls()"
            style="min-width: 150px"
          >
            Check Status Again
          </button>
          <button
            type="button"
            class="btn form-btn"
            style="
              background-color: #f5f5f5;
              color: #333;
              border: 1px solid #ddd;
              min-width: 150px;
            "
            (click)="contactSupport()"
          >
            Contact Support
          </button>
        </div>
      </div>

      <!-- Footer -->
      <div
        class="footer"
        style="margin-top: 20px; text-align: center; font-size: 8px"
      >
        <app-footer [whiteLabelInfo]="whiteLabelInfo" />
      </div>
    </div>
  }
}

@if (failedResponse) {
  <div class="error-response">
    <img class="mb" src="../../../assets/rexpay/Failed.svg" alt="" />
    <div>
      {{ errorResponse }}
    </div>
  </div>
}
